import React from 'react';
import { Alert, alertClasses, AlertProps, styled } from '@mui/material';

interface RangeItemContainerProps extends AlertProps {
  selected?: boolean;
  mode: 'default' | 'reply' | 'suggest';
}

export const RangeItemContainer = styled(
  ({ selected, ...alertProps }: RangeItemContainerProps) => (
    <Alert variant="outlined" severity="success" icon={false} {...alertProps} />
  ),
  {
    shouldForwardProp: prop => !['selected'].includes(prop as any),
  }
)(({ selected = false, theme, mode }) => ({
  [`&.${alertClasses.root}`]: {
    border: `1px solid ${
      mode === 'reply' || mode === 'suggest'
        ? `rgb(123, 81, 173)`
        : theme.palette.success.light
    }`,
    cursor: 'pointer',
    backgroundColor: selected
      ? mode === 'reply' || mode === 'suggest'
        ? `rgb(123, 81, 173,0.25)`
        : `rgba(227, 247, 201, 0.5)`
      : 'inherit',
    paddingRight: 20,
    // color: selected ? (mode === 'reply' ? 'white' : 'inherit') : 'inherit',
    // fontWeight: mode === 'reply' ? 'bold' : 'inherit',
    [`.${alertClasses.action}`]: {
      display: 'none',
    },

    '&:hover': {
      backgroundColor:
        mode === 'reply' || mode === 'suggest'
          ? `rgb(123, 81, 173,0.2)`
          : `rgba(227, 247, 201, 0.25)`,

      [`.${alertClasses.action}`]: {
        display: 'flex',
      },
    },
  },
}));
